import React from 'react';
import { ButtonGroup, Divider, Flex } from '@zillow/constellation';
import BackButton from '../BackButton';
import NextButton from '../NextButton';

export default function IdvFooter({ ...footerProps }) {
  return (
    <footer {...footerProps}>
      <Divider />
      <Flex
        as={ButtonGroup}
        display="flex"
        marginY="sm"
        marginX={{ default: 'xl', md_lte: 'sm' }}
        justifyContent="space-between"
        alignItems="center"
        aria-label="Back or Next buttons"
      >
        <span>
          <BackButton />
        </span>
        <span>
          <NextButton />
        </span>
      </Flex>
    </footer>
  );
}
